import { useEffect, useState } from "react";
import { ApplicationUpdateToast } from "@insights/ui";
import { watchAppVersion } from "./app-version";

export function AppVersionNotifier() {
  const [availableVersion, setAvailableVersion] = useState<string | null>(null);

  useEffect(() => watchAppVersion(setAvailableVersion), []);

  if (availableVersion === null) {
    return null;
  }

  return (
    <ApplicationUpdateToast
      onReload={() => {
        window.location.reload();
      }}
    />
  );
}
